import React from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Card,
  CardBody,
  CardTitle
} from "reactstrap";
import {
  Block,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  Row,
  Col,
  PreviewAltCard
} from "../../components/Component";
import { useNavigate } from "react-router";

const SubUserDashPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Head title="Balance and overview" />
      <Content>
        <BlockHead size="sm">
          <div className="nk-block-between">
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Welcome
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>As a user that is a part of an organisation you have access to the following tools.</p>
              </BlockDes>
            </BlockHeadContent>
          </div>
        </BlockHead>

        <Block>
          <Row className="g-gs">
            <Col lg="4" md="6" className="mb-4">
              <PreviewAltCard className="h-100">
                <Card className="h-100">
                  <CardBody>
                    <CardTitle tag="h5">Chat App</CardTitle>
                    <p className="mb-2 ff-base">
                      Simple web app for dispatchers, customer support, and team communication. Send messages, manage contacts, and stay connected — just like on your phone, but online.
                    </p>
                    <Button
                      className="btn-dim w-100 mt-3"
                      outline
                      color="primary"
                      onClick={() => navigate("/dashboard/chat")}
                    >
                      <Icon name="chat-circle" className="me-2" />
                      Go to Chat App
                    </Button>
                  </CardBody>
                </Card>
              </PreviewAltCard>
            </Col>

            <Col lg="4" md="6" className="mb-4">
              <PreviewAltCard className="h-100">
                <Card className="h-100">
                  <CardBody>
                    <CardTitle tag="h5">No-Code Outreach</CardTitle>
                    <p className="mb-2 ff-base">
                      Easily send customized messages at scale — no coding required. Perfect for follow-ups, campaigns, and contact-based outreach.
                    </p>
                    <p className="mb-2 ff-base text-warning">
                      ❗ Please do not spam random numbers. Focus on high-quality contacts.
                    </p>
                    <Button
                      className="btn-dim w-100 mt-3"
                      outline
                      color="primary"
                      onClick={() => navigate("/dashboard/bulksms-dashboard")}
                    >
                      <Icon name="send" className="me-2" />
                      Go to Outreach Dashboard
                    </Button>
                  </CardBody>
                </Card>
              </PreviewAltCard>
            </Col>

            <Col lg="4" md="6" className="mb-4">
              <PreviewAltCard className="h-100">
                <Card className="h-100">
                  <CardBody>
                    <CardTitle tag="h5">GHL Integration</CardTitle>
                    <p className="mb-2 ff-base">
                      Seamlessly connect your GoHighLevel location to this BluBubl sub-account. Set up API key, assign devices, and sync conversations effortlessly.
                    </p>
                    <Button
                      className="btn-dim w-100 mt-3"
                      outline
                      color="primary"
                      onClick={() => navigate("/dashboard/gohighlevel-setup")}
                    >
                      <Icon name="link" className="me-2" />
                      Go to GHL Setup
                    </Button>
                  </CardBody>
                </Card>
              </PreviewAltCard>
            </Col>
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default SubUserDashPage;
